<template>
  <div class="field">
    <label :class="this.$parent.isFieldRequired(this.keyData) ? 'req': ''">{{ label }}</label>
    <template v-if="type === 'input'">
      <input :value="currentData" @change="updateServerValue" type="text">
    </template>
    <template v-if="type === 'textarea'">
      <textarea @change="updateServerValue" :value="currentData"></textarea>
    </template>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "BaseJsonField.vue",
  props: [
    'currentData',
    'keyData',
    'label',
    'type',
    'objectKey'
  ],
  data() {
    return {

    }
  },
  methods: {
    async updateServerValue(e) {
      let project_data = this.$parent.project.project_data;
      project_data[this.keyData] = e.target.value;

      let obj = {
        'projectData': project_data
      }
      this.$parent.isDataUpdating = true;
      await axios.patch('/api/projects/' + window.projectId,
        obj,
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/merge-patch+json',
          }
        }
      ).catch(error => {
        console.log(error);
        alert('Ошибка получения данных')
      });
      this.$parent.getData();
      this.$parent.isDataUpdating = false;
    },

  }
}
</script>

<style scoped>

</style>